<div class="step-container">
  <h2 class="step-title">Crear contraseña</h2>
  <p class="step-subtitle">
    Ingrese una contraseña numérica de entre 6 y 50 dígitos.
    La utilizará para acceder a su cuenta.
  </p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="step-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Contraseña numérica</mat-label>
      <input
        matInput
        formControlName="password"
        [type]="hidePassword ? 'password' : 'text'"
        placeholder="Ingrese su contraseña"
        inputmode="numeric"
        maxlength="50" />
      <mat-icon matPrefix>lock</mat-icon>
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hidePassword = !hidePassword">
        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error *ngIf="form.get('password')?.hasError('required')">
        La contraseña es obligatoria.
      </mat-error>
      <mat-error *ngIf="form.get('password')?.hasError('pattern')">
        La contraseña debe contener solo números.
      </mat-error>
      <mat-error *ngIf="form.get('password')?.hasError('minlength')">
        La contraseña debe tener al menos 6 dígitos.
      </mat-error>
      <mat-error *ngIf="form.get('password')?.hasError('maxlength')">
        La contraseña no puede superar los 50 dígitos.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Confirmar contraseña</mat-label>
      <input
        matInput
        formControlName="confirmPassword"
        [type]="hideConfirm ? 'password' : 'text'"
        placeholder="Repita su contraseña"
        inputmode="numeric"
        maxlength="50" />
      <mat-icon matPrefix>lock_outline</mat-icon>
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hideConfirm = !hideConfirm">
        <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      <mat-error *ngIf="form.get('confirmPassword')?.hasError('required')">
        Debe confirmar la contraseña.
      </mat-error>
      <mat-error *ngIf="form.get('confirmPassword')?.hasError('mismatch')">
        Las contraseñas no coinciden.
      </mat-error>
    </mat-form-field>

    <div *ngIf="errorMessage" class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <button
      mat-raised-button
      color="primary"
      class="action-button"
      type="submit"
      [disabled]="loading">
      <mat-spinner *ngIf="loading" diameter="24" class="button-spinner"></mat-spinner>
      <span *ngIf="!loading">Guardar contraseña</span>
    </button>
  </form>
</div>
